import React from "react";
import { useTranslation } from "react-i18next";
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import { Traslates, SimpleLoading } from "../../pures";
import "./grid-document-tracking.css";

/* === Custom Component for th elements of the Grid === */
const signerCellHeader = (props) => {
  const stylesSpanCellHeader = {
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    color: "#123513",
    fontSize: "14px",
    fontFamily: "Quicksand, sans-serif",
  };

  const stylesIconCellHeader = {
    marginLeft: "4px",
  };

  let iconFilter = "k-i-arrows-swap";
  if (props.children !== false) {
    iconFilter =
      props.children[0].props.className === "k-icon k-i-sort-asc-sm"
        ? "k-i-sort-asc-sm"
        : "k-i-sort-desc-sm";
  }

  return (
    <span style={stylesSpanCellHeader} onClick={props.onClick}>
      {props.title}
      <i style={stylesIconCellHeader} className={`k-icon ${iconFilter}`}></i>
    </span>
  );
};

const GridDocumentTrackingPureGeneralHeaderStyle = (props) => {
  const gridColumnGeneralStyle = {
    fontSize: "14px",
    color: "#123513",
    display: "flex",
    alignItems: "center",
    fontFamily: "Quicksand, sans-serif",
  };

  return <span style={gridColumnGeneralStyle}>{props.title}</span>;
};

const GridDocumentTrackingPure = (props) => {
  const { t } = useTranslation();
  const gridLabelNorecordsStyles = {
    color: "#828282",
    fontSize: "15px",
    fontWeight: 500,
  };

  let { events, total, filter, group, skip, take, sort } = props;
  const resultData = {
    data: events,
    total,
  };
  const otherProps = {
    filter: filter ? filter : undefined,
    group: group ? group : undefined,
    sort: sort ? sort : [],
    skip,
    take,
  };

  return (
    <div className="grid-events-document-tracking">
      {props.loading ? (
        <SimpleLoading />
      ) : (
        <Traslates>
          <Grid
            className="request-detail-event"
            data={resultData}
            {...otherProps}
            sortable={true}
            resizable={true}
            reorderable={true}
            pageable={{
              info: false,
              buttonCount: 5,
              type: "numeric",
              previousNext: true,
            }}
            onDataStateChange={props.dataStateChange}
          >
            <GridColumn
              field="dateAndHour"
              title={t("gridDocumentTracking.dateAndHour")}
              width="auto"
              headerCell={signerCellHeader}
            />
            <GridColumn
              field="eventBinnacle.eventBinnacleType.name"
              title={t("gridDocumentTracking.actions")}
              width="auto"
              sortable={false}
              headerCell={GridDocumentTrackingPureGeneralHeaderStyle}
            />
            <GridColumn
              field="nameSigner"
              title={t("gridDocumentTracking.user")}
              width="auto"
              sortable={false}
              headerCell={GridDocumentTrackingPureGeneralHeaderStyle}
            />
            <GridNoRecords>
              <p style={gridLabelNorecordsStyles}>
                {t("gridDocumentTracking.noDataToShow")}
              </p>
            </GridNoRecords>
          </Grid>
        </Traslates>
      )}
    </div>
  );
};
export { GridDocumentTrackingPure as default };
